/**
 * @author Matthew Rogers
 */
var bindingsBPLM = { vm: '=' };
var ReportBPLMController = (function () {
    function ReportBPLMController($scope, env, $filter, socket, settings) {
        var _this = this;
        this.$scope = $scope;
        this.env = env;
        this.$filter = $filter;
        this.socket = socket;
        this.settings = settings;
        this.visible = false;
        this.details = { fired: false, loaded: false, err: false };
        this.excel = { fired: false, downloaded: false, err: false };
        this.viewLog = false;
        this.viewUser = false;
        this.err = { error: false, message: '' };
        this.data = {};
        this.logs = [];
        this.visible = false;
        this.socket.forward('return.bplm.report', this.$scope);
        this.$scope.$on('socket:return.bplm.report', function (event, data) {
            _this.excel.fired = false;
            if (!data.error) {
                var a = document.createElement('A');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none;');
                var url = window.URL.createObjectURL(new Blob([data.file], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }));
                a.setAttribute('href', url);
                a.setAttribute('download', _this.data.fileName);
                a.click();
                _this.err = { error: false, message: '' };
                _this.excel.downloaded = true;
                _this.excel.err = false;
            }
            else {
                _this.err.error = true;
                _this.excel.err = true;
                _this.err.message = data.error;
            }
        });
        this.socket.forward('return.bplm.details', this.$scope);
        this.$scope.$on('socket:return.bplm.details', function (event, data) {
            _this.details.fired = false;
            if (data.error) {
                _this.err.error = true;
                _this.details.err = true;
                _this.err.message = data.error;
                return;
            }
            _this.data = data.bplm;
            _this.logs = data.bplm.lastrun_log;
            _this.details.loaded = true;
            _this.details.err = false;
            _this.err = { error: false, message: '' };
            _this.fileSize = (_this.data.report_details.rows || 0) + ' rows';
        });
    }
    ReportBPLMController.prototype.toggle = function () {
        this.visible = !this.visible;
        //If report already pulled, don't bother pulling again
        if (this.visible && !this.details.loaded) {
            this.getBPLMDetails();
        }
    };
    ReportBPLMController.prototype.getBPLMDetails = function () {
        this.details.fired = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                email: this.env.user.email,
                function: 'getBPLMDetails',
                script: '/reporting/reporting',
                user: this.env.user
            }
        });
    };
    ReportBPLMController.prototype.getReport = function () {
        var a = document.createElement('A');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none;');
        a.setAttribute('href', "/bplm");
        a.click();
    };
    ReportBPLMController.$inject = ['$scope', 'env', '$filter', 'socket', 'settings'];
    return ReportBPLMController;
}());
var ReportBPLMComponent = (function () {
    function ReportBPLMComponent() {
        this.templateUrl = 'report-bplm.html';
        this.bindings = bindingsBPLM;
        this.controller = ReportBPLMController;
    }
    return ReportBPLMComponent;
}());
angular
    .module('application')
    .component('reportBplm', new ReportBPLMComponent());

//# sourceMappingURL=reporting.bplm.component.js.map
